import { DevicesAPI, IGetDeviceByNameParams } from "../../services/hcnApi";

export const getDeviceBatteryHistoryUseCase = async (
  params: IGetDeviceByNameParams
) => {
  try {
    return DevicesAPI.getDeviceBatteryHistory(params);
  } catch (err) {
    console.log(err);
  }
};
